import { Platform } from 'react-native'

/**
 * Font for weight-800 numbers: the map's troop counts, region bonuses and
 * attack losses, and count bubbles. Only Inter Regular is bundled, so web
 * browsers fake the 800 wherever the Google Fonts link doesn't load (the dev
 * server, tests). Fake bolds differ: Safari's is thin, and Firefox's also
 * shifts the glyph, which put bubble digits off-centre. Web uses a local
 * Inter ExtraBold under its own family name ('Inter ExtraBold', declared in
 * public/index.html) so other Inter text keeps its weight. Native keeps its
 * current default.
 */
export function heavyNumberFont(): string | undefined {
  // Read at render, not import: tests mock react-native without Platform.
  return Platform.OS === 'web' ? "'Inter ExtraBold', Inter, system-ui, sans-serif" : undefined
}
